import { useEffect, useState } from 'react';
import litvikLogo from '../img/litvik_logo.jpg';
import { subscribeLoading } from '../utils/loadingBus';
import './LitvikLoadingOverlay.css';

export default function LitvikLoadingOverlay() {
  const [open, setOpen] = useState(false);

  useEffect(() => subscribeLoading(setOpen), []);

  if (!open) {
    return null;
  }

  return (
    <div className="litvik-loader" role="status" aria-live="polite" aria-busy="true">
      <div className="litvik-loader__card">
        <img src={litvikLogo} alt="Litvik" className="litvik-loader__logo" />
        <p className="litvik-loader__text">Loading...</p>
      </div>
    </div>
  );
}
